import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { CommonPageComponent } from "@shared/components/commons/common-page/common-page.component";
import { IPartialHeaderData } from "@shared/services/header.service";
import { settingsLinksBlocks } from "./settings.constant";

@Component({
  selector: 'app-settings',
  standalone: true,
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss', '../../styles/settings-styles.scss'],
  imports: [
    RouterLink
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsPageComponent extends CommonPageComponent {
  readonly linkBlocks = settingsLinksBlocks;
  override readonly headerData: IPartialHeaderData = { title: 'Settings', iconClass: 'ic-settings-20' };
}
